import * as React from "react";
import {option} from "ts-option";
import {api} from "../../../../api/api";
import Modal from "../../../ui/modal/Modal";
import SingleFileSelector from "../../../file/SingleFileSelector";
import Toast from "../../../helper/Toast";
import ButtonPrimary from "../../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import {PartnerBrandVehiclesImportResult} from "../../../../model/importVehicles/PartnerBrandVehiclesImportResult";
import PartnerBrandVehiclesImportResultsTile from "../PartnerBrandVehiclesImportResultsTile";

interface IComponentProps {
	/**
	 * Partner brand id.
	 */
	partnerBrandId: string;
	/**
	 * On modal close.
	 */
	onClose: () => void;
}

interface IState {
	/**
	 * Indicates if files are uploading
	 */
	filesUploading: boolean;
	/**
	 * Upload errors to display
	 */
	errors: string[];
	/**
	 * Import results to display
	 */
	importResult: PartnerBrandVehiclesImportResult | null;
}

type Props = IComponentProps

export default class UploadPartnerBrandVehiclesModal extends React.PureComponent<Props, IState> {

	constructor(props: Props) {
		super(props);
		this.state = {filesUploading: false, errors: [], importResult: null};
		this.uploadFile = this.uploadFile.bind(this);
	}

	render() {
		return (
			<Modal onCloseClicked={this.props.onClose} title={"Import partner brand vehicles"}>
				{!this.state.importResult ? (
					<SingleFileSelector onUpload={this.uploadFile}
										onCancel={this.props.onClose}
										errors={option(this.state.errors)}
										filesUploading={this.state.filesUploading}
										accept={".csv,.xls,.xlsx"}/>
				) : (
					<>
						<PartnerBrandVehiclesImportResultsTile result={this.state.importResult}/>
						<div style={{display: 'flex', justifyContent: 'center', marginTop: '20px'}}>
							<ButtonPrimary label="Close" onClick={this.props.onClose}/>
						</div>
					</>
				)}
			</Modal>
		);
	}

	uploadFile(file: File) {
		if (file) {
			this.setState({filesUploading: true}, () => {
				api.instance.partnerBrandApi.uploadPartnerBrandVehicles(this.props.partnerBrandId, file).then((response) => {
					const result = PartnerBrandVehiclesImportResult.fromJson(response);
					Toast.success("Vehicles imported successfully.", "Partner brand vehicles import");
					this.setState({filesUploading: false, importResult: result});
				}).catch((_: any) => {
					const errors: string[] = [];
					this.setState({errors, filesUploading: false});
					Toast.error("Cannot import partner brand vehicles.", "Partner brand vehicles import");
				});
			});
		}
	}
}
